import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { CSSProperties } from "@material-ui/styles";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import TableCellHeader from "@saleor/components/TableCellHeader";
import TablePagination from "@saleor/components/TablePagination";
import { maybe, renderCollection } from "@saleor/misc";
import { ListProps } from "@saleor/types";
import React from "react";
import { FormattedMessage } from "react-intl";
import Moment from "react-moment";

import { ProductDetailsBiList_productDetails_edges_node } from "../../types/ProductDetailsBiList";
const useStyles = makeStyles(
  theme => {
    const overflowing: CSSProperties = {
      overflow: "hidden",
      textOverflow: "ellipsis"
    };
    return {
      colMedium: {
        overflowing,
        width: "10em",
        [theme.breakpoints.down("md")]: {
          width: "auto"
        }
      },
      colNarrow: {
        overflowing,
        width: "5em",
        [theme.breakpoints.down("md")]: {
          width: "auto"
        }
      },
      colRow: {
        "& th": {
          fontWeight: 600 as 600,
          paddingBottom: theme.spacing(1),
          paddingTop: theme.spacing(1)
        }
      },
      colWide: {
        overflowing,
        width: "18em",
        [theme.breakpoints.down("md")]: {
          width: "auto"
        }
      },
      table: {
        tableLayout: "fixed"
      },
      tableRow: {
        cursor: "pointer"
      }
    };
  },
  { name: "ProductDetailsBiList" }
);

export interface ProductDetailsBiListProps extends ListProps {
  productDetails: ProductDetailsBiList_productDetails_edges_node[];
}

export const ProductDetailsBiList: React.FC<ProductDetailsBiListProps> = ({
  productDetails,
  onNextPage,
  onPreviousPage,
  onRowClick,
  onUpdateListSettings,
  pageInfo,
  settings,
  disabled
}) => {
  const colNum = 3;
  const classes = useStyles({});

  return (
    <>
      <ResponsiveTable className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCellHeader className={classes.colMedium}>
              <FormattedMessage defaultMessage="Product" />
            </TableCellHeader>
            <TableCellHeader className={classes.colMedium}>
              <FormattedMessage defaultMessage="Product Status" />
            </TableCellHeader>
            <TableCellHeader className={classes.colMedium}>
              <FormattedMessage defaultMessage="Update Date" />
            </TableCellHeader>
          </TableRow>
        </TableHead>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={colNum}
              settings={settings}
              hasNextPage={
                pageInfo && !disabled ? pageInfo.hasNextPage : undefined
              }
              onNextPage={onNextPage}
              onUpdateListSettings={onUpdateListSettings}
              hasPreviousPage={
                pageInfo && !disabled ? pageInfo.hasPreviousPage : undefined
              }
              onPreviousPage={onPreviousPage}
            />
          </TableRow>
        </TableFooter>
        <TableBody>
          {productDetails &&
            renderCollection(
              productDetails,
              productDetail => (
                <TableRow
                  className={!!productDetail ? classes.tableRow : undefined}
                  hover={!!productDetail}
                  key={productDetail ? productDetail.id : "skeleton"}
                  onClick={
                    productDetail
                      ? onRowClick(btoa(`Product:${atob(productDetail.id)}`))
                      : undefined
                  }
                >
                  <TableCell>
                    {maybe<React.ReactNode>(
                      () => productDetail.product_name,
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell>
                    {maybe<React.ReactNode>(
                      () => productDetail.product_status,
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell>
                    <Moment format="YYYY-MM-DD HH:mm:ss" tz="Asia/Manila">
                      {productDetail.updated_at ? (
                        productDetail.updated_at
                      ) : (
                        <Skeleton />
                      )}
                    </Moment>
                  </TableCell>
                </TableRow>
              ),
              () => (
                <TableRow>
                  <TableCell colSpan={colNum}>
                    <FormattedMessage defaultMessage="No product details found" />
                  </TableCell>
                </TableRow>
              )
            )}
        </TableBody>
      </ResponsiveTable>
    </>
  );
};

export default ProductDetailsBiList;
